import React from 'react'

/**
 * RINA — l'emoji renard, source unique (DESIGN-SYSTEM.md §4).
 *
 * RINA s'affiche TOUJOURS via cet emoji 🦊 (rendu Apple). Si un jour on passe a
 * un asset SVG/PNG (renard identique sur tous les OS), ne changer QUE ce
 * composant : tout le reste (carte RINA, FAB, intro, modale) suit.
 */
export default function Fox({ size = 40, className = '' }) {
  return (
    <span
      role="img"
      aria-label="RINA"
      className={className}
      style={{
        fontSize: size,
        lineHeight: 1,
        display: 'inline-block',
        filter: 'drop-shadow(0 4px 8px rgba(7,62,61,0.18))',
      }}
    >
      🦊
    </span>
  )
}
